import React from "react";
import { CheckDocuments } from "../features";
import { Grid } from "@material-ui/core";

function checkDocumentsPage() {
  return (
    <>
      <CheckDocuments.Container />
    </>
  );
}

export default checkDocumentsPage;
